module.exports = {"data":{"themenJson":{"thema":"sport","monat_num":4,"thema_cover_uri":"04_2006.jpg","jahr":2006,"monat":"April","id":"thema_50","issue_date":"200604","moving_image_count":1,"still_image_count":4,"textz_count":1,"soundz_count":0}},"pathContext":{"id":"thema_50"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/issue-200604.json
// module id = 836
// module chunks = 93744048979146